// extracted by mini-css-extract-plugin
export default {"root":"errorblock_root__IHR2n","title":"errorblock_title__hjA58","text":"errorblock_text__C2BfB"};